// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/feature/hotel/hotel_policies.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/feature/hotel/hotel_policies.proto.
 */
export const file_proto_model_feature_hotel_hotel_policies = /*@__PURE__*/
  fileDesc("Ci5wcm90by9tb2RlbC9mZWF0dXJlL2hvdGVsL2hvdGVsX3BvbGljaWVzLnByb3RvEgZjYXJtZW4izAEKDUhvdGVsUG9saWNpZXMSGwoTY2FuY2VsbGF0aW9uX3BvbGljeRgBIAEoCRISCgpwZXRfcG9saWN5GAIgASgJEhQKDGNoaWxkX3BvbGljeRgDIAEoCRItCg5zbW9raW5nX3BvbGljeRgEIAEoDjIVLmNhcm1lbi5TbW9raW5nUG9saWN5EhMKC21pbmltdW1fYWdlGAUgASgFEhcKD2lkX3JlcXVpcmVtZW50cxgGIAMoCRIXCg9wYXltZW50X21ldGhvZHMYByADKAkqmAEKDVNtb2tpbmdQb2xpY3kSHgoaU01PS0lOR19QT0xJQ1lfVU5TUEVDSUZJRUQQABIeChpTTU9LSU5HX1BPTElDWV9OT05fU01PS0lORxABEiIKHlNNT0tJTkdfUE9MSUNZX1NNT0tJTkdfQUxMT1dFRBACEiMKH1NNT0tJTkdfUE9MSUNZX0RFU0lHTkFURURfQVJFQVMQA0I2WjRnaXRodWIuY29tL3l1bmFjYWJhL2Nhcm1lbi9wcm90by9tb2RlbC9mZWF0dXJlL2hvdGVsYgZwcm90bzM");

/**
 * Describes the message carmen.HotelPolicies.
 * Use `create(HotelPoliciesSchema)` to create a new message.
 */
export const HotelPoliciesSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_hotel_hotel_policies, 0);

/**
 * Describes the enum carmen.SmokingPolicy.
 */
export const SmokingPolicySchema = /*@__PURE__*/
  enumDesc(file_proto_model_feature_hotel_hotel_policies, 0);

/**
 * @generated from enum carmen.SmokingPolicy
 */
export const SmokingPolicy = /*@__PURE__*/
  tsEnum(SmokingPolicySchema);

